



































import { Vue, Component } from 'vue-property-decorator';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import ErrorMonitorFilter from '@/domain/error-monitor/entity/error-monitor-filter.entity';
import ErrorMonitorEntity from '@/domain/error-monitor/entity/error-monitor.entity';
import Pagination from '@/domain/pagination.entity';
import ErrorMonitorService from '@/domain/error-monitor/service/error-monitor.service';
import EventBus, { Event } from '@/event.bus';
import ErrorMonitorDatatable from './error-monitor-datatable/error-monitor-datatable.component.vue';
import FilterComponent from './error-monitor-datatable/error-monitor-filtro.component.vue';
import ErrorMonitorDetailed from './error-monitor-detailed/error-monitor-detailed-modal.view.vue';

@Component({
  components: {
    ErrorMonitorDatatable,
    FilterComponent,
    ErrorMonitorDetailed,
  },
})

export default class ErrorMonitor extends Vue {
  businessUnitId: string = '';

  filter: ErrorMonitorFilter = new ErrorMonitorFilter({});

  pagination: Pagination = new Pagination();

  errorMonitorList: ErrorMonitorEntity[] = [];

  loading: boolean = false;

  showBillingItensModal: boolean = false;

  errorMonitorSelected: string = '';

  keyErrorDetailed: number = 1;

  updateField(field: string, value: any): void {
    this.filter[field] = value;
  }

  viewDetails(id: string): void {
    this.keyErrorDetailed += 1;
    this.errorMonitorSelected = id;
    this.showBillingItensModal = true;
  }

  closeModal(): void {
    this.showBillingItensModal = false;
    this.errorMonitorSelected = '';
  }

  clearFilters(): void {
    this.filter = new ErrorMonitorFilter({});
    this.filter.periodStart = '';
    this.filter.periodEnd = '';
    this.filter.selectedDates = [];
    this.applyFilter(this.filter);
  }

  applyFilter(filter: ErrorMonitorFilter): void {
    this.filter = ErrorMonitorFilter.of(filter);
    this.filter.prepareToSend();
    this.pagination.page = 1;
    this.loadErrorMonitors();
  }

  loadErrorMonitors(): void {
    if (this.loading || !this.businessUnitId) return;

    this.loading = true;
    this.filter.prepareToSend();
    ErrorMonitorService.getAll(
      this.businessUnitId,
      this.filter.toRequest(),
      this.pagination,
    ).then((response: any) => {
      this.pagination.total = response.totalElements;
      this.pagination.pageCount = response.totalPages;
      this.errorMonitorList = ErrorMonitorEntity.ofList(response.content);
    }).finally(() => {
      this.loading = false;
    });
  }

  updatePagination(pagination: Pagination) {
    this.pagination = pagination;
    this.pagination.verifyPage();
    this.loadErrorMonitors();
  }

  created(): void {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnitId: BusinessUnit) => {
      if (this.$route.name && (this.$route.name.includes('error-monitor'))) {
        this.businessUnitId = businessUnitId.id;
        this.loadErrorMonitors();
      }
    });
    this.loadErrorMonitors();
  }
}

